import type { BigNumber, BigNumberish } from '@ethersproject/bignumber';
import { formatUnits, parseUnits } from '@ethersproject/units';

const bigNumberToNumber = (bn: BigNumberish, decimals = 18): number => {
  return parseFloat(formatUnits(bn, decimals));
};

function convertScientificToDecimal(numStr: string): string {
  const num = Number(numStr);
  if (Math.abs(num) >= 1.0e21 || (Math.abs(num) < 1.0e-7 && num !== 0)) {
    // This will convert any number in scientific notation or large decimal to standard form
    const sign = num < 0 ? '-' : '';
    const arr = numStr.toString().split('e');
    let base = arr[0];
    let exponent = arr.length > 1 ? parseInt(arr[1]) : 0;

    if (base.includes('.')) {
      base = base.replace('.', '');
      exponent--;
    }

    if (exponent >= 0) {
      const zeros = '0'.repeat(exponent);
      return sign + base + zeros;
    } else {
      const zeros = '.' + '0'.repeat(Math.abs(exponent) - 1);
      return sign + zeros + base;
    }
  } else {
    return num.toString();
  }
}

export const numberToBigNumber = (
  n: number | undefined | null,
): BigNumber | undefined => {
  if (n === undefined || n === null) return undefined;
  const decimalNumStr = convertScientificToDecimal(n.toString());
  return parseUnits(decimalNumStr);
};

export default bigNumberToNumber;
